import moment from 'moment-timezone';
import { Constants } from './constants';

// Guess timezone of browser
const guessTimezone = () => (moment.tz.guess(Constants.IgnoreCachedTimezone));

export const getBrowserTimezoneCode = () => {
  const tz = moment.tz.guess();
  return moment.tz(tz).format('z');
};

// Common abbreviation -> IANA timezone mappings
const TZ_ALIASES = {
  AT: 'America/Halifax',
  EST: 'America/New_York',
  CST: 'America/Chicago',
  MST: 'America/Denver',
  PST: 'America/Los_Angeles',
  AKST: 'America/Anchorage',
  HAST: 'Pacific/Honolulu',
};

function resolveTimezone(timezone) {
  if (!timezone) return 'EST';
  const tz = String(timezone).trim();
  const up = tz.toUpperCase();

  // Map common abbreviations (EST, CST, AT, etc.) to IANA zones
  if (TZ_ALIASES[up]) return TZ_ALIASES[up];

  // Assume it's already an IANA timezone name
  return tz;
}

const DateUtil = {
  /**
  * Format the date
  * @param  {Date|timestamp|moment} date
  * @param  {String} format The expected format
  * @return {String} The date with expected format
  */
  format(date, format) {
    return moment(date).format(format);
  },

  /**
   * Format the date in UTC format to expected format that in timezone
   * @param  {Date|timestamp|moment} date
   * @param  {String} format The expected format
   * @param  {String} timezone Timezone id
   * @return {String} The date in timezone with expected format
   */
  formatUTC(date, format, timezone) {
    return moment.utc(date).tz(timezone).format(format);
  },

  /**
   * Format the date and time in expected format that in timezone
   * @param  {Date|timestamp|moment} date
   * @param  {String} format The expected format
   * @param  {String} timezone Timezone
   * @return {String} The date in timezone with expected format
   */
  formatDateTimeZone(date, format, timezone) {
    const resolvedTz = resolveTimezone(timezone);
    return moment(date).tz(resolvedTz).format(format);
  },

  /**
   * Get date in timezone
   * @param  {Date} date
   * @param  {String} timezone
   * @return {Date} Date in timezone
   */
  getDateInTimezone(date, timezone = guessTimezone()) {
    return moment(date).tz(timezone);
  },

  /**
   * Get date in UTC.
   * @param {Date} date
   * @return {Date} Date in UTC mode
   */
  utc(date) {
    return moment.utc(date);
  },
};

export default DateUtil;
